var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7073 7.70711C7.09783 7.31658 7.73099 7.31658 8.12152 7.70711L23.6779 23.2635C24.0684 23.654 24.0684 24.2871 23.6779 24.6777C23.2873 25.0682 22.6542 25.0682 22.2637 24.6777L6.7073 9.12132C6.31678 8.7308 6.31678 8.09763 6.7073 7.70711Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6778 7.70696C24.0683 8.09748 24.0683 8.73064 23.6778 9.12117L8.12141 24.6775C7.73089 25.068 7.09772 25.068 6.7072 24.6775C6.31668 24.287 6.31668 23.6538 6.7072 23.2633L22.2635 7.70696C22.6541 7.31643 23.2872 7.31643 23.6778 7.70696Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.1b8d7f0349aed4b7973a4e8e0e4891f1.svg";